export const API_URLS = {
  AUTH: {
    LOGIN: `auth/login`,
    ADMINLOGIN: `auth/admin-login`,
    VERIFY_2FA: `auth/verify-2fa`,
    SETUP_2FA_START: `auth/2fa-setup/start`,
    SETUP_2FA_VERIFY: `auth/2fa-setup/verify`,
    LOGOUT: `auth/logout`,
    REFRESH: `auth/refresh`,
  },
  AUDIT: {
    LOGS: `audit/logs`,
  },
  BACKUP: {
    OVERVIEW: `backup/overview`,
    DATABASES: `backup/databases`,
    OFFSITE_CHECK: `backup/offsite/check`,
    RUNS: `backup/runs`,
    RUN_LIST: `backup/runs/list`,
    TASK_LIST: `backup/tasks/list`,
    COPIES: `backup/copies`,
    SETTINGS: `backup/settings`,
  },
  CHAT_MODERATION: {
    MUTES: `chat/mutes`,
    MUTE: `chat/mute`,
    UNMUTE: (userId: string) => `chat/mute/${userId}`,
  },
  RISK: {
    FLAG_LIST: `risk/flags/list`,
    FLAGS: `risk/flags`,
    REVIEW: (id: string) => `risk/flags/${id}/review`,
    NOTES: (userId: string) => `risk/notes/${userId}`,
    PLAYER_LIST: `risk/players/list`,
    TAGS: `risk/tags`,
    PLAYER: (userId: string) => `risk/players/${userId}`,
    PLAYER_LINKS: (userId: string) => `risk/players/${userId}/links`,
    PLAYER_SCAN: (userId: string) => `risk/players/${userId}/scan`,
    PLAYER_TAGS: (userId: string) => `risk/players/${userId}/tags`,
    PLAYER_CLUSTER: (userId: string) => `risk/players/${userId}/cluster`,
    PLAYER_HOLD: (userId: string) => `risk/players/${userId}/hold`,
    PLAYER_HOLD_RELEASE: (userId: string) => `risk/players/${userId}/hold/release`,
    CASE_LIST: `risk/cases/list`,
    CASES: `risk/cases`,
    CASE_TAKE: (id: string) => `risk/cases/${id}/take`,
    CASE_NOTE: (id: string) => `risk/cases/${id}/note`,
    CASE_CLOSE: (id: string) => `risk/cases/${id}/close`,
  },
  BET_LIMITS: {
    ROWS: `bet-limits/rows`,
    ROW: (id: string) => `bet-limits/rows/${id}`,
    GROUPS: `bet-limits/groups`,
    GROUP: (code: string) => `bet-limits/groups/${code}`,
    PLAYER: (userId: string) => `bet-limits/players/${userId}`,
  },
  ANALYTICS: {
    SUMMARY: `analytics/summary`,
    COHORTS: `analytics/cohorts`,
    PROVIDERS: `analytics/providers`,
    AFFILIATES: `analytics/affiliates`,
    CHANNELS: `analytics/channels`,
  },
  TRANSLATION: {
    LIST: `translation/list`,
    OVERRIDE: `translation/override`,
    RESET: `translation/override/reset`,
    PUBLIC: `translation/public`,
  },
  RESPONSIBLE_GAMING: {
    OVERVIEW: (userId: string) => `responsible-gaming/${userId}`,
    HISTORY: (userId: string) => `responsible-gaming/${userId}/history`,
    LIFT_EXCLUSION: (userId: string) => `responsible-gaming/${userId}/lift-exclusion`,
  },
  PRIVACY: {
    ERASURE_PREVIEW: (userId: string) => `privacy/${userId}/erasure-preview`,
    ERASE: (userId: string) => `privacy/${userId}/erase`,
  },
  USER: {
    USER: `user`,
    CREATE_PLAYER: `user/player`,
    GET_USERS_LIST: `user/list`,
    GET_SUPER_AGENT_OPTIONS: `user/super-agent-options`,
    GET_AGENT_OPTIONS: `user/agent-options`,
    GET_AGENT_LIST: `user/agent-list`,
    PAYMENT_FILTER_TENANTS: `user/payment-filter/tenants`,
    PAYMENT_FILTER_AGENTS: `user/payment-filter/agents`,
    PAYMENT_FILTER_PLAYERS: `user/payment-filter/players`,
    CHANGE_PASSWORD: `user/change-password`,
    USER_BY_ID: (id: string) => `user/${id}`,
    USER_UPDATE_BRAND: (id: string) => `user/${id}/brand`,
    USER_BLOCK: (id: string) => `user/${id}/block`,
    USER_LOGIN_METHODS: (id: string) => `user/${id}/login-methods`,
    USER_PROFILE: (userId: string) => `user/${userId}/user-profile`,
    USER_MFA_SETTINGS: (userId: string) => `user/${userId}/user-mfa-settings`,
  },
  SESSION: {
    GET_SESSIONS_LIST: `session/list`,
    LOGOUT: (id: string) => `session/${id}/logout`,
  },
  ROLE: {
    ROLE: `role`,
    GET_ROLES_LIST: `role/list`,
    GET_ROLE_OPTIONS: `role/options`,
    ROLE_BY_ID: (id: string) => `role/${id}`,
  },
  TENANT: {
    TENANT: `tenant`,
    GET_TENANTS_LIST: `tenant/list`,
    GET_TENANT_OPTIONS: `tenant/options`,
    TENANT_BY_ID: (id: string) => `tenant/${id}`,
  },
  TEMPLATE: {
    TEMPLATE: `template`,
    GET_TEMPLATES_LIST: `template/list`,
    GET_TEMPLATE_OPTIONS: `template/options`,
    TEMPLATE_BY_ID: (id: string) => `template/${id}`,
  },
  BASE_LANGUAGE: {
    LANGUAGE: `base/language`,
    GET_LANGUAGES_LIST: `base/language/list`,
    GET_LANGUAGE_OPTIONS: `base/language/options`,
    LANGUAGE_BY_ID: (id: string) => `base/language/${id}`,
    MOVE: (id: string) => `base/language/${id}/move`,
  },
  BASE_COUNTRY: {
    COUNTRY: `base/country`,
    GET_COUNTRIES_LIST: `base/country/list`,
    GET_COUNTRY_OPTIONS: `base/country/options`,
    COUNTRY_BY_ID: (id: string) => `base/country/${id}`,
    MOVE: (id: string) => `base/country/${id}/move`,
  },
  BASE_CURRENCY: {
    CURRENCY: `base/currency`,
    GET_CURRENCIES_LIST: `base/currency/list`,
    GET_CURRENCY_OPTIONS: `base/currency/options`,
    CURRENCY_BY_ID: (id: string) => `base/currency/${id}`,
    MOVE: (id: string) => `base/currency/${id}/move`,
  },
  BRAND: {
    BRAND: `brand`,
    GET_BRANDS_LIST: `brand/list`,
    GET_BRAND_OPTIONS: `brand/options`,
    BRAND_BY_ID: (id: string) => `brand/${id}`,
    SYNC: (id: string) => `brand/${id}/sync`,
  },
  MEDIA: {
    UPLOAD: `media/upload`,
  },
  LOGIN_HISTORY: {
    GET_LOGIN_HISTORIES_LIST: `login-history/list`,
    FINGERPRINT_EVENT: (id: string) => `login-history/${id}/fingerprint-event`,
  },
  TRACKING_WHITELIST: {
    LIST: `tracking-whitelist/list`,
    ADD: `tracking-whitelist/add`,
    REMOVE: (id: string) => `tracking-whitelist/${id}`,
  },
  GEO_ACCESS: {
    LIST: `geo-access/list`,
    ADD: `geo-access`,
    SETTINGS: `geo-access/settings`,
    REMOVE: (id: string) => `geo-access/${id}`,
  },
  SERVER_SWITCHES: {
    LIST: `server-switches`,
    ONE: (key: string) => `server-switches/${key}`,
  },
  REPORT_SCHEDULE: {
    BASE: `analytics/schedules`,
    LIST: `analytics/schedules/list`,
    RECIPIENTS: `analytics/schedules/recipients`,
    BY_ID: (id: string) => `analytics/schedules/${id}`,
    RUN: (id: string) => `analytics/schedules/${id}/run`,
  },
  SKY: {
    SETTINGS: `sky/settings`,
    RATE_APPROVE: `sky/settings/rate/approve`,
    RATE_REJECT: `sky/settings/rate/reject`,
    SWAP_LIST: `sky/swaps/list`,
    SWAP_APPROVE: (id: string) => `sky/swaps/${id}/approve`,
    SWAP_REJECT: (id: string) => `sky/swaps/${id}/reject`,
  },
  PAYMENT: {
    GET_PAYMENTS_LIST: `payment/list`,
    USER_WALLETS: (userId: string) => `payment/user/${userId}/wallets`,
    DEPOSIT: `payment/deposit`,
    WITHDRAW: `payment/withdraw`,
    ADJUSTMENT_PREVIEW: `payment/adjustments/preview`,
    ADJUSTMENT_LIST: `payment/adjustments/list`,
    WITHDRAW_APPROVE: (id: string) => `payment/withdraw/${id}/approve`,
    WITHDRAW_REJECT: (id: string) => `payment/withdraw/${id}/reject`,
    // Crypto payouts only. Approving a crypto withdrawal dispatches it to the
    // gateway rather than settling it, so these cover the states that follow.
    WITHDRAW_CRYPTO_RETRY: (id: string) => `payment/withdraw/${id}/crypto-retry`,
    WITHDRAW_CRYPTO_RECHECK: (id: string) => `payment/withdraw/${id}/crypto-recheck`,
    WITHDRAW_CRYPTO_CANCEL: (id: string) => `payment/withdraw/${id}/crypto-cancel`,
    WITHDRAW_CRYPTO_FAIL_UNDISPATCHED: (id: string) =>
      `payment/withdraw/${id}/crypto-fail-undispatched`,
    // Credits a deposit the gateway credited but whose webhook never landed.
    CRYPTO_DEPOSIT_CREDIT_FROM_GATEWAY: (depositId: string) =>
      `payment/crypto-deposit/${depositId}/credit-from-gateway`,
    // The currencies the TON gateway will accept right now, read live from it.
    // Its limits and pause state are its own to decide, so there is nothing
    // mirrored on our side that could show an operator a stale answer.
    CRYPTO_ASSETS: `payment/crypto/assets`,
    MY_BALANCE: `payment/me/balance`,
  },
  USER_KYC: {
    LIST: `user-kyc/list`,
    DETAIL: (userId: string) => `user-kyc/${userId}`,
    REVIEW: (userId: string) => `user-kyc/${userId}/review`,
    FILE: (userId: string, fileId: string) => `user-kyc/${userId}/files/${fileId}`,
  },
  // Per-country availability and the casino's withdrawal fee per payment method.
  PAYMENT_METHOD_RULE: {
    RULE: `payment-method-rule/`,
    LIST: `payment-method-rule/list`,
    BY_ID: (id: string) => `payment-method-rule/${id}`,
  },
  SOLVENCY: {
    SUMMARY: `report/solvency/summary`,
    DEPOSITS: `report/solvency/deposits`,
  },
  PAYMENT_PROVIDER: {
    PROVIDER: `payment-provider`,
    GET_PROVIDERS_LIST: `payment-provider/list`,
    GET_PROVIDER_OPTIONS: `payment-provider/options`,
    PROVIDER_BY_ID: (id: string) => `payment-provider/${id}`,
  },
  CASINO_AGGREGATOR: {
    AGGREGATOR: `casino-aggregator`,
    GET_AGGREGATORS_LIST: `casino-aggregator/list`,
    GET_AGGREGATOR_OPTIONS: `casino-aggregator/options`,
    AGGREGATOR_BY_ID: (id: string) => `casino-aggregator/${id}`,
  },
  CASINO_GAME_TYPE: {
    GAME_TYPE: `casino-game-type`,
    GET_GAME_TYPES_LIST: `casino-game-type/list`,
    GET_GAME_TYPE_OPTIONS: `casino-game-type/options`,
    GAME_TYPE_BY_ID: (id: string) => `casino-game-type/${id}`,
    MOVE: (id: string) => `casino-game-type/${id}/move`,
  },
  CASINO_CATEGORY: {
    CATEGORY: `casino-category`,
    GET_LIST: `casino-category/list`,
    OPTIONS: `casino-category/options`,
    BY_ID: (id: string) => `casino-category/${id}`,
    MOVE: (id: string) => `casino-category/${id}/move`,
  },
  CASINO_PROVIDER: {
    PROVIDER: `casino-provider`,
    GET_PROVIDERS_LIST: `casino-provider/list`,
    GET_PROVIDER_OPTIONS: `casino-provider/options`,
    PROVIDER_BY_ID: (id: string) => `casino-provider/${id}`,
    MOVE: (id: string) => `casino-provider/${id}/move`,
  },
  CASINO_GAME: {
    GAME: `casino-game`,
    GET_GAMES_LIST: `casino-game/list`,
    GAME_BY_ID: (id: string) => `casino-game/${id}`,
    BULK_DELETE: `casino-game/bulk-delete`,
    MOVE: (id: string) => `casino-game/${id}/move`,
  },
  GAME_SYNC: {
    SKYSTAKE: (aggregatorId: string) => `game/skystake-games?aggregatorId=${aggregatorId}`,
    SKYCASINO: (aggregatorId: string) => `game/skycasino-games?aggregatorId=${aggregatorId}`,
    SKYLG: (aggregatorId: string) => `game/skylg-games?aggregatorId=${aggregatorId}`,
    PLATIPUS: (aggregatorId: string) => `game/platipus-games?aggregatorId=${aggregatorId}`,
    BETORA: (aggregatorId: string) => `game/betora-games?aggregatorId=${aggregatorId}`,
    NOTIX: (aggregatorId: string) => `game/notix-games?aggregatorId=${aggregatorId}`,
    ONEGAMEHUB: (aggregatorId: string) => `game/onegamehub-games?aggregatorId=${aggregatorId}`,
  },
  USER_VIP: {
    BY_USER: (userId: string) => `user-vip/${userId}`,
    ADJUST: (userId: string) => `user-vip/${userId}/adjust`,
  },
  WALLET_LEDGER: {
    GET_LEDGER_LIST: `wallet-ledger/list`,
  },
  BONUS_WALLET_LEDGER: {
    GET_LIST: `bonus-wallet-ledger/list`,
  },
  BONUS_GRANT: {
    GET_LIST: `promotion/bonus-grant/list`,
  },
  PROMOTION_VIP_LIST: {
    GET_LIST: `promotion/vip-list/list`,
    CREATE: `promotion/vip-list`,
    BY_ID: (id: string) => `promotion/vip-list/${id}`,
  },
  PROMOTION_VIP_SOURCE: {
    GET_LIST: `promotion/vip-source/list`,
    CREATE: `promotion/vip-source`,
    BY_ID: (id: string) => `promotion/vip-source/${id}`,
    MOVE: (id: string) => `promotion/vip-source/${id}/move`,
  },
  PROMOTION_CAMPAIGN: {
    GET_LIST: `promotion/campaign/list`,
    CREATE: `promotion/campaign`,
    BY_ID: (id: string) => `promotion/campaign/${id}`,
    STATUS: (id: string) => `promotion/campaign/${id}/status`,
  },
  REFERRAL: {
    GET_LIST: `referral/list`,
  },
  JACKPOT: {
    CONFIG: `jackpot/config`,
    CONFIG_LIST: `jackpot/config/list`,
    CONFIG_BY_ID: (id: string) => `jackpot/config/${id}`,
    RESET: (id: string) => `jackpot/config/${id}/reset`,
    WINS_LIST: `jackpot/wins/list`,
  },
  DAILY_SPIN: {
    CONFIG: `daily-spin/config`,
    CONFIG_LIST: `daily-spin/config/list`,
    CONFIG_BY_ID: (id: string) => `daily-spin/config/${id}`,
    HISTORY_LIST: `daily-spin/history/list`,
  },
  SLOT_BATTLE: {
    LIST: `slot-battle/list`,
    BY_ID: (id: string) => `slot-battle/${id}`,
    CANCEL: (id: string) => `slot-battle/${id}/cancel`,
  },
  WAGER_RACE: {
    CONFIG: `wager-race/config`,
    CONFIG_LIST: `wager-race/config/list`,
    CONFIG_BY_ID: (id: string) => `wager-race/config/${id}`,
    STANDINGS: (id: string) => `wager-race/config/${id}/standings`,
    RESULTS_LIST: `wager-race/results/list`,
  },
  CHALLENGE: {
    CONFIG: `challenge/config`,
    CONFIG_LIST: `challenge/config/list`,
    CONFIG_BY_ID: (id: string) => `challenge/config/${id}`,
    WINNERS_LIST: `challenge/winners/list`,
  },
  RAFFLE: {
    CONFIG: `raffle/config`,
    CONFIG_LIST: `raffle/config/list`,
    CONFIG_BY_ID: (id: string) => `raffle/config/${id}`,
    STANDINGS: (id: string) => `raffle/config/${id}/standings`,
    RESULTS_LIST: `raffle/results/list`,
  },
  VIP_BOOST: {
    CONFIG: `vip-boost/config`,
    CONFIG_LIST: `vip-boost/config/list`,
    CONFIG_BY_ID: (id: string) => `vip-boost/config/${id}`,
    REWARDS_LIST: `vip-boost/rewards/list`,
  },
  DAILY_CHECKIN: {
    CONFIG: `daily-checkin/config`,
    CONFIG_LIST: `daily-checkin/config/list`,
    CONFIG_BY_ID: (id: string) => `daily-checkin/config/${id}`,
    RECORDS_LIST: `daily-checkin/records/list`,
  },
  GAME_BOT: {
    ROOT: `game-bot`,
    LIST: `game-bot/list`,
    BY_ID: (id: string) => `game-bot/${id}`,
    SETTINGS: `game-bot/settings`,
    SETTING: (game: string) => `game-bot/settings/${game}`,
  },
  VIP_HOST: {
    ROOT: `vip-host`,
    LIST: `vip-host/list`,
    BY_ID: (id: string) => `vip-host/${id}`,
    PLAYERS_LIST: `vip-host/players/list`,
    ASSIGN: `vip-host/assign`,
  },
  RAKEBACK: {
    CONFIG: `rakeback/config`,
    CONFIG_LIST: `rakeback/config/list`,
    CONFIG_BY_ID: (id: string) => `rakeback/config/${id}`,
    CLAIMS_LIST: `rakeback/claims/list`,
  },
  MISSION: {
    CONFIG: `mission/config`,
    CONFIG_LIST: `mission/config/list`,
    CONFIG_BY_ID: (id: string) => `mission/config/${id}`,
    PROGRESS_LIST: `mission/progress/list`,
  },
  LOYALTY_STORE: {
    CONFIG: `loyalty-store/config`,
    CONFIG_LIST: `loyalty-store/config/list`,
    CONFIG_BY_ID: (id: string) => `loyalty-store/config/${id}`,
    ITEMS: `loyalty-store/items`,
    ITEMS_LIST: `loyalty-store/items/list`,
    ITEM_BY_ID: (id: string) => `loyalty-store/items/${id}`,
    PURCHASES_LIST: `loyalty-store/purchases/list`,
    BALANCE: (userId: string) => `loyalty-store/balance/${userId}`,
    ADJUST: `loyalty-store/adjust`,
  },
  TIPPING: {
    CONFIG: `tipping/config`,
    TIPS_LIST: `tipping/tips/list`,
    RAINS_LIST: `tipping/rains/list`,
    RAIN: `tipping/rain`,
  },
  REPORT_GAME: {
    GET_LIST: `report/game/list`,
  },
  TEMPLATE_SIDEBAR: {
    SIDEBAR: `template-sidebar`,
    GET_SIDEBARS_LIST: `template-sidebar/list`,
    GET_SIDEBAR_OPTIONS: `template-sidebar/options`,
    SIDEBAR_BY_ID: (id: string) => `template-sidebar/${id}`,
    MOVE: (id: string) => `template-sidebar/${id}/move`,
  },
  TEMPLATE_BANNER: {
    BANNER: `template-banner`,
    GET_BANNERS_LIST: `template-banner/list`,
    BANNER_BY_ID: (id: string) => `template-banner/${id}`,
    MOVE: (id: string) => `template-banner/${id}/move`,
  },
  TEMPLATE_FAQ: {
    FAQ: `template-faq`,
    GET_FAQS_LIST: `template-faq/list`,
    FAQ_BY_ID: (id: string) => `template-faq/${id}`,
    MOVE: (id: string) => `template-faq/${id}/move`,
  },
  TEMPLATE_FOOTER_LIST: {
    LIST: `template-footer-list`,
    BY_TEMPLATE: (templateId: string) => `template-footer-list?templateId=${templateId}`,
    BY_ID: (id: string) => `template-footer-list/${id}`,
    MOVE: (id: string) => `template-footer-list/${id}/move`,
  },
  TEMPLATE_FOOTER_ITEM: {
    LIST: `template-footer-item`,
    LIST_PAGINATED: `template-footer-item/list`,
    BY_PID: (pid: string) => `template-footer-item?pid=${pid}`,
    BY_ID: (id: string) => `template-footer-item/${id}`,
    MOVE: (id: string) => `template-footer-item/${id}/move`,
  },
  TEMPLATE_FOOTER_IMAGE: {
    LIST: `template-footer-image`,
    BY_TEMPLATE: (templateId: string) => `template-footer-image?templateId=${templateId}`,
    BY_ID: (id: string) => `template-footer-image/${id}`,
    MOVE: (id: string) => `template-footer-image/${id}/move`,
  },
  BRAND_SIDEBAR: {
    LIST: `brand-sidebar`,
    BY_BRAND: (brandId: string) => `brand-sidebar?brandId=${brandId}`,
    BY_ID: (id: string) => `brand-sidebar/${id}`,
    MOVE: (id: string) => `brand-sidebar/${id}/move`,
    PARENTS: `brand-sidebar/parents`,
    PARENTS_REMOVE: `brand-sidebar/parents/remove`,
    PARENTS_MOVE: `brand-sidebar/parents/move`,
  },
  BRAND_BANNER: {
    LIST: `brand-banner`,
    BY_BRAND: (brandId: string) => `brand-banner?brandId=${brandId}`,
    BY_ID: (id: string) => `brand-banner/${id}`,
    MOVE: (id: string) => `brand-banner/${id}/move`,
  },
  BRAND_FOOTER_LIST: {
    LIST: `brand-footer-list`,
    BY_BRAND: (brandId: string) => `brand-footer-list?brandId=${brandId}`,
    BY_ID: (id: string) => `brand-footer-list/${id}`,
    MOVE: (id: string) => `brand-footer-list/${id}/move`,
  },
  BRAND_FOOTER_ITEM: {
    LIST: `brand-footer-item`,
    LIST_PAGINATED: `brand-footer-item/list`,
    BY_PID: (pid: string) => `brand-footer-item?pid=${pid}`,
    BY_ID: (id: string) => `brand-footer-item/${id}`,
    MOVE: (id: string) => `brand-footer-item/${id}/move`,
  },
  BRAND_FOOTER_IMAGE: {
    LIST: `brand-footer-image`,
    BY_BRAND: (brandId: string) => `brand-footer-image?brandId=${brandId}`,
    BY_ID: (id: string) => `brand-footer-image/${id}`,
    MOVE: (id: string) => `brand-footer-image/${id}/move`,
  },
  ADMIN_SIDEBAR: {
    SIDEBAR: `permission/admin-sidebar`,
    SIDEBAR_BY_ID: (id: string) => `permission/admin-sidebar/${id}`,
  },
  SITE_FUNCTION: {
    FUNCTION: `permission/site-function`,
    GET_FUNCTIONS_LIST: `permission/site-function/list`,
    FUNCTION_BY_ID: (id: string) => `permission/site-function/${id}`,
    USER_PERMISSIONS: `permission/site-function/user-permissions`,
  },
  FUNCTION_GROUP: {
    GROUP: `permission/function-group`,
    GET_GROUPS_LIST: `permission/function-group/list`,
    GET_GROUP_OPTIONS: `permission/function-group/options`,
    GROUP_BY_ID: (id: string) => `permission/function-group/${id}`,
  },
  PROVIDER_PERMISSION: {
    SAVE: `permission/provider-permission`,
    BY_USER: (userId: string) => `permission/provider-permission/${userId}`,
  },
  BRAND_PROVIDER_PERMISSION: {
    SAVE: `permission/brand-provider-permission`,
    BY_USER: (userId: string) => `permission/brand-provider-permission/${userId}`,
  },
  CRM_NOTIFICATION: {
    SEND: `crm/notification/send`,
    LIST: `crm/notification`,
    UNREAD_COUNT: `crm/notification/unread-count`,
    READ_ALL: `crm/notification/read-all`,
    VIEWED: (id: string) => `crm/notification/${id}/viewed`,
    REMOVE: (id: string) => `crm/notification/${id}`,
  },
  DASHBOARD: {
    OVERVIEW: `dashboard/overview`,
  },
  SUPPORT_HISTORY: {
    GET_LIST: `support-history/list`,
    BY_ID: (id: string) => `support-history/${id}`,
  },
  SUPPORT_WIDGET: {
    ROOT: `support-widget`,
    BY_ID: (id: string) => `support-widget/${id}`,
  },
  HELP_CENTER: {
    CATEGORY: `help-center/category`,
    CATEGORY_OPTIONS: `help-center/category/options`,
    CATEGORY_BY_ID: (id: string) => `help-center/category/${id}`,
    ARTICLE: `help-center/article`,
    ARTICLE_LIST: `help-center/article/list`,
    ARTICLE_PREVIEW: `help-center/article/preview`,
    ARTICLE_BY_ID: (id: string) => `help-center/article/${id}`,
  },
  SITE_PAGE: {
    ROOT: `site-page`,
    PREVIEW: `site-page/preview`,
    BY_LANGUAGE: (slug: string, language: string) => `site-page/${slug}/${language}`,
  },
};
